export default "__VITE_ASSET__9b036e99__"